import { countBy, Dictionary, find, get, includes, pickBy } from 'lodash';

import { IBudget, IBudgetSlot } from '../types/store/budget';
import { IKitItem, IProSupportItem, IRegionData, IRouterData } from '../types/store/routerData';
import { ISlotRegion, ISlotsItems } from '../types/store/slotsItems';

const getRegionItem = (region: string, itemRegionSection: IRegionData): ISlotRegion =>
  itemRegionSection[region] ? itemRegionSection[region] : itemRegionSection.Worldwide;

const removeMatchKitMaterial = (routerKits: IKitItem[], kitId: string, allMaterials: IMaterial[]) => {
  const routerKit = find(routerKits, ['id', kitId]) as IKitItem;
  const kitConditions = get(routerKit, 'conditions', {}) as { [key: string]: number };
  const conditionsKeys = Object.keys(kitConditions);
  return allMaterials
    .map(
      material =>
        includes(conditionsKeys, material.id)
          ? { ...material, qty: material.qty - kitConditions[material.id] }
          : material
    )
    .filter(material => material.qty > 0);
};

const itemBudgetToMaterial = (itemsBudget: IBudgetSlot[], slotsItems: ISlotsItems, region: string): IMaterial[] => {
  const budgetSlotsCountByType = countBy(itemsBudget, 'filled');

  return Object.keys(budgetSlotsCountByType).map(slotItemId => ({
    id: slotItemId,
    sku: getRegionItem(region, slotsItems[slotItemId].region).sku,
    name: slotsItems[slotItemId].name,
    qty: budgetSlotsCountByType[slotItemId]
  }));
};

const getMaterialsProSupport = (
  servicesBudget: { [key: string]: boolean },
  allServices: { [key: string]: IProSupportItem },
  region: string
): IMaterial[] => {
  const proSupportSelected = pickBy(servicesBudget, Boolean);

  return Object.keys(proSupportSelected).map(proSupportServiceId => ({
    id: proSupportServiceId,
    sku: getRegionItem(region, allServices[proSupportServiceId].region).sku,
    name: allServices[proSupportServiceId].name,
    qty: 1
  }));
};

const matchKitConditions = (conditions: { [key: string]: number }, portsCount: Dictionary<number>) =>
  Object.keys(conditions).reduce(
    (before, conditionID) => before && portsCount[conditionID] >= conditions[conditionID],
    true
  );

const getRouterKit = (itemsBudget: IBudgetSlot[], routerKits: IKitItem[]) => {
  const budgetSlotsCountByType = countBy(itemsBudget, 'filled');
  return routerKits.reduce(
    (finalKit, kitToMatch) =>
      kitToMatch.conditions === undefined
        ? kitToMatch
        : matchKitConditions(kitToMatch.conditions, budgetSlotsCountByType)
          ? kitToMatch
          : finalKit
  );
};

const kitToMaterial = (kit: IKitItem, aregion: string) => ({
  id: kit.id,
  sku: getRegionItem(aregion, kit.region).sku,
  name: kit.name,
  qty: 1
});

const getMaterialsRouter = (allPortsBudgetItems: IBudgetSlot[], routerData: IRouterData, region: string): IMaterial => {
  return kitToMaterial(getRouterKit(allPortsBudgetItems, routerData.kits), region);
};

// Export

export interface IMaterial {
  id: string;
  sku: string;
  name: string;
  qty: number;
}

export const getAllMaterials = (
  allPortsBudgetItems: IBudgetSlot[],
  slotsItems: ISlotsItems,
  budget: IBudget,
  routerData: IRouterData
): IMaterial[] => {
  let materials: IMaterial[] = new Array().concat(
    itemBudgetToMaterial(allPortsBudgetItems, slotsItems, budget.region),
    getMaterialsProSupport(budget.proSupport, routerData.proSupport, budget.region)
  );
  const materialKit = getMaterialsRouter(allPortsBudgetItems, routerData, budget.region);
  materials.unshift(materialKit);
  materials = removeMatchKitMaterial(routerData.kits, materialKit.id, materials);
  return materials;
};



// WEBPACK FOOTER //
// ./src/utils/manageBudgetMaterial.ts